
export const MAX_CHECK_AUTOCODE = 100;
export const MAX_AUTO = 100;
export const TARIFFS_TRANSLATIONS_MAP = {
    start: 'Старт',
    optima: 'Оптима',
    maxi: 'Макси'
}

export const INSURANCE_CARDS = [
    {
        tariff: 'start',
        title: TARIFFS_TRANSLATIONS_MAP.start,
        subtitle: 'Для начинающих предпринимателей',
        subtitlePrice: 'Сумма выплаты до 750 000 ₽',
        price: '390',
        listItems: [
            {
                text: 'Конструктив + Внутренняя отделка + инженерное оборудование + Витрина и стекла',
                price: '350 000',
                tooltip: 'Конструктивные элементы помещения (площадью до 1 000м2) на сумму 200 000 ₽\n' +
                    'Внутренняя отделка здания/помещения (площадью до 1 000 м2) на сумму 100 000 ₽\n' +
                    'Оконные стёкла, витрины, внутреннее остекление на сумму 50 000 ₽\n',
            },
            {
                text: 'Движимое имущество + Товарно-материальные ценности + Контрольно-кассовая техника',
                price: '225 000',
                tooltip: 'Движимое имущество (мебель, предметы интерьера, электронное, технологическое оборудование, бытовая и оргтехника) на сумму 100 000 ₽\n' +
                    'Товарно-материальные ценности в  обороте (в торговом помещении или подсобном помещении торгового зала) на сумму 100 000 ₽\n' +
                    'Контрольно-кассовая техника/терминал (ККТ) на сумму 15 000 ₽\n' +
                    'Дополнительные расходы на аренду подменного ККТ на сумму 10 000 ₽\n',
            },
            {
                text: 'Гражданская ответственность + убытки от приостановки деятельности',
                price: '175 000',
                tooltip: 'Гражданская ответственность Страхователя перед третьими лицами при эксплуатации здания/помещения на сумму 75 000 ₽\n' +
                    'Страхование убытков от перерыва в производстве (возмещаются только чистая прибыль и постоянные издержки) на сумму 100 000 ₽\n',
            },
        ]
    },
    {
        tariff: 'optima',
        title: TARIFFS_TRANSLATIONS_MAP.optima,
        subtitle: 'Для малого бизнеса',
        subtitlePrice: 'Сумма выплаты до 1 500 000 ₽',
        tooltipText: 'Какая-то подсказка для большего понимания написанного в карточке',
        mark: {
            text: 'Популярно', type: 'comment'
        },
        price: '690',
        listItems: [
            {
                text: 'Конструктив + Внутренняя отделка + инженерное оборудование + Витрина и стекла',
                price: '800 000',
                tooltip: 'Конструктивные элементы помещения (площадью до 1 000м2) на сумму 500 000 ₽\n' +
                    'Внутренняя отделка здания/помещения (площадью до 1 000 м2) на сумму 200 000 ₽\n' +
                    'Оконные стёкла, витрины, внутреннее остекление на сумму 100 000 ₽\n',
            },
            {
                text: 'Движимое имущество + Товарно-материальные ценности + Контрольно-кассовая техника',
                price: '450 000',
                tooltip: 'Движимое имущество (мебель, предметы интерьера, электронное, технологическое оборудование, бытовая и оргтехника) на сумму 200 000 ₽\n' +
                    'Товарно-материальные ценности в  обороте (в торговом помещении или подсобном помещении торгового зала) на сумму 200 000 ₽\n' +
                    'Контрольно-кассовая техника/терминал (ККТ) на сумму 25 000 ₽\n' +
                    'Дополнительные расходы на аренду подменного ККТ на сумму 25 000 ₽\n',
            },
            {
                text: 'Гражданская ответственность + убытки от приостановки деятельности',
                price: '250 000',
                tooltip: 'Гражданская ответственность Страхователя перед третьими лицами при эксплуатации здания/помещения на сумму 150 000 ₽\n' +
                    'Страхование убытков от перерыва в производстве (возмещаются только чистая прибыль и постоянные издержки) на сумму 100 000 ₽\n',
            }
        ]
    },
    {
        tariff: 'maxi',
        title: TARIFFS_TRANSLATIONS_MAP.maxi,
        subtitle: 'Для среднего бизнеса',
        subtitlePrice: 'Сумма выплаты до 3 000 000 ₽',
        tooltipText: 'Какая-то подсказка для большего понимания написанного в карточке',
        mark: {
            text: '-20%', type: 'percent'
        },
        oldPrice: '1237',
        price: '990',
        listItems: [
            {
                text: 'Конструктив + Внутренняя отделка + инженерное оборудование + Витрина и стекла',
                price: '1 700 000',
                tooltip: 'Конструктивные элементы помещения (площадью до 1 000м2) на сумму 1 000 000 ₽\n' +
                    'Внутренняя отделка здания/помещения (площадью до 1 000 м2) на сумму 500 000 ₽\n' +
                    'Оконные стёкла, витрины, внутреннее остекление на сумму 200 000 ₽\n',
            },
            {
                text: 'Движимое имущество + Товарно-материальные ценности + Контрольно-кассовая техника',
                price: '900 000',
                tooltip: 'Движимое имущество (мебель, предметы интерьера, электронное, технологическое оборудование, бытовая и оргтехника) на сумму 500 000 ₽\n' +
                    'Товарно-материальные ценности в  обороте (в торговом помещении или подсобном помещении торгового зала) на сумму 300 000 ₽\n' +
                    'Контрольно-кассовая техника/терминал (ККТ) на сумму 50 000 ₽\n' +
                    'Дополнительные расходы на аренду подменного ККТ на сумму 50 000 ₽\n',
            },
            {
                text: 'Гражданская ответственность + убытки от приостановки деятельности',
                price: '400 000',
                tooltip: 'Гражданская ответственность Страхователя перед третьими лицами при эксплуатации здания/помещения на сумму 300 000 ₽\n' +
                    'Страхование убытков от перерыва в производстве (возмещаются только чистая прибыль и постоянные издержки) на сумму 100 000 ₽\n',
            }
        ]
    }
];

export const GLOBAL_MODAL_KEYS_MAP = {
    successPolicyIssuance: 'payment_success',
}

export const SUBSCRIPTION_CANCEL_REASONS = [
    { label: 'Больше не нравится страховка', value: 'dont_like_anymore' },
    { label: 'Не нравится ваш сервис', value: 'dont_like_service' },
    { label: 'Хочу внести изменения', value: 'want_to_change_conditions' },
    { label: 'Другая', value: 'another' },
]

export const CODE_REPEAT_MAX_TIMEOUT = 31;

export const COMPANY_INN_LENGTH = 12;

export const PERSON_INN_LENGTH = 10;

export const PHONE_LENGTH = 11;

export const CADASTRAL_CODE_LENGTH = 35;

export const PERSON_PASSPORT_LENGTH = 10;

export const PASSPORT_ISSUE_DATE_LENGTH = 8;

export const INN_VALID_MAP = {
    'Y': 'success',
    'N': 'not_found',
    'F': 'forbidden',
    'NM': 'not_match',
    'L': 'liquidated',
};

export const INN_ERRORS_MAP = {
    not_found: 'Ошибка поиска юридического лица по указанному ИНН',
    uncaught_error: 'Произошла непредвиденная ошибка, попробуйте снова',
    not_match: 'Выбранный тип страхователя не совпадает с данными по ИНН',
};

export const ORGANIZATION_TYPES_MAP = {
    individual: 'INDIVIDUAL',
    company: 'LEGAL'
};

export const MAX_ADDRESS_QUERY_LENGTH = 300;

export const CALCULATOR_TYPE = 'OSGOP';
